import $ from 'jquery'

$(document).on('submit', '.bhub-user-login-form form', function (e) {
  e.preventDefault()
  const button = $(this).find('button[type="submit"]')
  const nonce = $(this).find('#bhub_login').val()
  const log = $(this).find('#bhub_login_log').val()
  const pwd = $(this).find('#bhub_login_pwd').val()
  const wrapper = $(this).parent()
  wrapper.find('.bhub-user-login-form--error').remove()

  $.ajax({
    url: bookingHub.ajaxUrl,
    type: 'POST',
    data: {
      action: 'bhub_user_login',
      bhub_login: nonce,
      log: log,
      pwd: pwd,
    },
    beforeSend: function () {
      button.prop('disabled', true)
      button.addClass('loading')
      button.append(bookingHub.loader)
      button.find('.bhub-loader').css({
        '--bhub-loader-color': 'white',
        '--bhub-loader-size': '16px',
      })
    },
    success: function (response) {
      if (response.success) {
        if (response.data.redirect) {
          window.location.href = response.data.redirect
        } else {
          window.location.reload()
        }
      } else {
        wrapper.append(response.data.message)
      }
      button.find('.bhub-loader').remove()
      button.prop('disabled', false)
    },
  })
})

$(document).on('click', '.bhub-user-login-form--auth-profile', function () {
  let userData = $(this).data('user')
  $('.bhub-user-login-form--auth-profile').removeClass('bhub-active')
  $(this).addClass('bhub-active')

  $('#bhub_login_log').val(userData.user)
  $('#bhub_login_pwd').val(userData.pass)
})

$(window).on('load', function () {
  const urlParams = new URLSearchParams(window.location.search)
  const userIndex = parseInt(urlParams.get('user'), 10)

  if (!isNaN(userIndex) && userIndex > 0) {
    const $target = $('.bhub-user-login-form--auth-profile').eq(userIndex - 1)

    if ($target.length) {
      $target.trigger('click')
    }
  }
})

$(document).on('click', '.bhub-show-password', function () {
  const input = $('#bhub_login_pwd')
  const isPasswordVisible = input.attr('type') === 'text'

  if (isPasswordVisible) {
    input.attr('type', 'password')
    $(this).removeClass('bhub-active')
  } else {
    input.attr('type', 'text')
    $(this).addClass('bhub-active')
  }
})
